import INotificationConfig, { INotificationConfigDto } from '@/interfaces/INotificationConfig';

const notificationConfigAdapter = (notificationConfigs: INotificationConfigDto[]): INotificationConfig[] => {
  const formatConfigs: INotificationConfig[] = notificationConfigs.reduce((configs: INotificationConfig[], item) => {
    const foundKey = configs.findIndex(config => config.key === item.key);

    if (foundKey === -1) {
      configs.push({
        emailId: item.id,
        whatsappId: item.id,
        key: item.key,
        labelEs: item.labelEs,
        labelEn: item.labelEn,
        isEmail: item.type === 'email' ? item.defaultValue : undefined,
        isWhatsapp: item.type === 'whatsapp' ? item.defaultValue : undefined,
      });
    } else {
      if (item.type === 'email') {
        configs[foundKey].emailId = item.id;
        configs[foundKey].isEmail = item.defaultValue;
      } else if (item.type === 'whatsapp') {
        configs[foundKey].whatsappId = item.id;
        configs[foundKey].isWhatsapp = item.defaultValue;
      }
    }

    return configs;
  }, []);

  return formatConfigs;
};

export default notificationConfigAdapter;

